import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { COPY_DEFAULTS } from "../lib/copyRegistry";

const CopyContext = createContext({ t: (k) => COPY_DEFAULTS[k] || "", overrides: {} });

export function CopyProvider({ children }) {
  const [overrides, setOverrides] = useState({});
  useEffect(() => {
    api.get("/copy").then((r) => setOverrides(r.data || {})).catch(() => {});
  }, []);
  const t = (key) => overrides[key] || COPY_DEFAULTS[key] || "";
  return <CopyContext.Provider value={{ t, overrides }}>{children}</CopyContext.Provider>;
}

export const useCopy = () => useContext(CopyContext).t;
